import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// COMPONENTS

// MODULES
import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { FilterModule } from '../filter/filter.module';
import { RfqModule } from '../rfq/rfq.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { UiModule } from '../ui/ui.module';

import { DirectiveModule } from './../shared/directives/directive.module';
import {
  BomComponent,
  BomDetailsComponent,
  BomFormComponent,
  BomCreateButtonComponent,
  BomTableComponent,
  BomFiltersComponent,
} from './components';

const components = [
  BomComponent,
  BomDetailsComponent,
  BomFormComponent,
  BomCreateButtonComponent,
  BomTableComponent,
  BomFiltersComponent,
];

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];
const lumModules = [
  SharedComponentsModule,
  PipeModule,
  DirectiveModule,
  MaterialCustomModule,
  UiModule,
  FilterModule,
  RfqModule,
];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BomModule {}
